export default "__VITE_ASSET__B5L8mg_Z__"